import React, { useEffect, useState } from 'react';
import { Form } from 'reactstrap';
import { Box, Modal, Typography, TextField } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import SaveIcon from '@material-ui/icons/Save';
import InputLabel from '@material-ui/core/InputLabel';
import CloseIcon from '@material-ui/icons/Close';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import { styled, makeStyles } from '@material-ui/core/styles';
import MenuItem from '@material-ui/core/MenuItem';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import AddBoxIcon from '@material-ui/icons/AddBox';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import moment from "moment";

import MaterialJajeSerche from './MaterialJajeSerche'  //serche모달

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  height: 580,
  width: 800,
  bgcolor: 'background.paper',
  border: '1px solid #59b9ea',
  borderColor: 'primary.light',
  boxShadow: 24,
  p: 3,
};

const panelStyle = {
  position: 'absolute',
  top: '3.7%',
  left: '70%',
  bgcolor: 'background.paper',
  //border: '1px solid #000',
  borderColor: '#59b9ea',
  // marginTop:-10,
  //marginLeft: 10,
  textAlign: 'center',
  height: 60,
  width: 200,
}

const StyledTextField = styled(TextField)({
  "& .MuiInputLabel-root": {
    right: 0,
    textAlign: "center"
  },
  "& .MuiInputLabel-shrink": {
    margin: "0 auto",
    position: "absolute",
    right: "0",
    left: "0",
    top: "-3px",
    width: "90px", // Need to give it a width so the positioning will work
    background: "white" // Add a white bg
    // display: "none" //if you want to hide it completly
  },
  "& .MuiOutlinedInput-root.Mui-focused": {
    "& legend ": {
      display: "none" // If you want it then you need to position it similar with above
    }
  }
});

const CssSelect = styled(Select)({
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: '#59b9ea',
  },
  '& .MuiInputBase-input': {
    WebkitTextFillColor: 'green',
    color: 'red',
  },
});

const CssTextField = styled(TextField)({
  '& .MuiInputLabel-root': {
    // color: 'green',
  },
  '& .MuiInputBase-input': {
    // WebkitTextFillColor: 'green',
  },
  '& label.Mui-focused': {
    color: 'green',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: 'green',
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#59b9ea',
    },
    '&:hover fieldset': {
      borderColor: 'blue',
    },
    '&.Mui-focused fieldset': {
      borderColor: 'green',
    },
  },
});

const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1)
    }
  },
  textarea: {
    resize: "both"
  }
}));

const useStyles01 = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  formControl: {
    marginTop: theme.spacing(1),
  },
}));

function MaterialInputListEdit(props) {
  const { addOrEdit } = props
  const [materialJajeItemSerche, setMaterialJajeItemSerche] = useState('') //모달검색찾기
  const [materialJajeItemSercheValue, setMaterialJajeItemSercheValue] = useState('') //모달더블클릭자료 담기

  const [materialJajeId] = useState(props.materialInputListEditValue.Id) // id
  const [materialGongJang, setMaterialGongJang] = useState(props.materialInputListEditValue.ms_공장구분) // 공장선택
  const [materialIpchul, setMaterialIpchul] = useState(props.materialInputListEditValue.ms_입고출고구분) // 입출구분
  const [materialUpche, setMaterialUpche] = useState(props.materialInputListEditValue.ms_업체명) // 자재업체
  const [materialCodeNo, setMaterialCodeNo] = useState(props.materialInputListEditValue.ms_업체코드) //자재업체코드
  const [materialSubul, setMaterialSubul] = useState(props.materialInputListEditValue.ms_자재수불) //자재수불
  const [materialGamokCode, setMaterialGamokCode] = useState(props.materialInputListEditValue.ms_계정과목코드) //계정과목코드
  const [materialGamok, setMaterialGamok] = useState(props.materialInputListEditValue.ms_계정과목내용) //계정과목
  const [materialJajeCode, setMaterialJajeCode] = useState(props.materialInputListEditValue.ms_자재코드) //자재코드
  const [materialJajeItem, setMaterialJajeItem] = useState(props.materialInputListEditValue.ms_자재품번) //자재품번
  const [materialJajeStandader, setMaterialJajeStandader] = useState(props.materialInputListEditValue.ms_자재규격) //자재규격[품명]
  const [materialJichulBulru, setMaterialJichulBulru] = useState(props.materialInputListEditValue.ms_자재지출분류); //업체자재지출분류
  const [materialJajeDanwiQuantity, setMaterialJajeDanwiQuantity] = useState(props.materialInputListEditValue.ms_단위량) //자재단위량
  const [materialJajeDanwi, setMaterialJajeDanwi] = useState(props.materialInputListEditValue.ms_단위) //자재단위
  const [materialJajeDanga, setMaterialJajeDanga] = useState(props.materialInputListEditValue.ms_자재단가) //자재단가
  const [materialJajeIpgoQuantity, setMaterialJajeIpgoQuantity] = useState(props.materialInputListEditValue.ms_수량) //자재입고수량
  const [materialJajeIpgoGumackQuantity, setMaterialJajeIpgoGumackQuantity] = useState(props.materialInputListEditValue.ms_금액) //자재입고금액
  const [materialJajeIpgoGumackSeack, setMaterialJajeIpgoGumackSeack] = useState(props.materialInputListEditValue.ms_세액) //자재입고금액세액
  const [materialJajeIpgoGumackSegum, setMaterialJajeIpgoGumackSegum] = useState(props.materialInputListEditValue.계산서) //자재세금계산서 금액
  const [checked, setChecked] = React.useState(true); //세액적용유무
  const [materialJajeGubun, setMaterialJajeGubun] = useState(props.materialInputListEditValue.ms_자재구분) //자재구분
  const [materialJajeIpChulDate, setMaterialJajeIpChulDate] = useState(props.materialInputListEditValue.ms_입출일자) //입출일자
  const [materialJajeDateTime, setMaterialJajeDateTime] = useState(props.materialInputListEditValue.ms_결재지급월) //대금지급월
  const [materialJajeIpgoGigubGumack, setMaterialJajeIpgoGigubGumack] = useState(props.materialInputListEditValue.ms_결재지급금액) //결재금액
  const [materialJajeJigubDateTime, setMaterialJajeJigubDateTime] = useState(props.materialInputListEditValue.ms_결재지급일자) //결재지급일자
  const [materialGelje, setMaterialGelje] = useState(props.materialInputListEditValue.ms_결재유무) //결재유무
  const [materialJajeDescription, setMaterialJajeDescription] = useState(props.materialInputListEditValue.ms_자재설명) //기타기록사항

  const [materialJajeModal, setMaterialJajeModal] = useState(false) //모달

  const classes = useStyles();
  const classes01 = useStyles01();

  useEffect(() => {
    // console.log(materialJajeItemSercheValue)
    if (materialJajeItemSercheValue !== '') {
      setMaterialUpche(materialJajeItemSercheValue.r_자재업체명)
      setMaterialCodeNo(materialJajeItemSercheValue.r_자재업체코드)
      setMaterialSubul(materialJajeItemSercheValue.r_자재수불)
      setMaterialGamokCode(materialJajeItemSercheValue.r_자재계정과목코드)
      setMaterialGamok(materialJajeItemSercheValue.r_자재계정과목)
      setMaterialJajeCode(materialJajeItemSercheValue.r_자재코드)
      setMaterialJajeItem(materialJajeItemSercheValue.r_자재품번)
      setMaterialJajeStandader(materialJajeItemSercheValue.r_자재규격)
      setMaterialJichulBulru(materialJajeItemSercheValue.r_자재지출분류)
      setMaterialJajeDanwiQuantity(materialJajeItemSercheValue.r_자재단위량)
      setMaterialJajeDanwi(materialJajeItemSercheValue.r_자재단위)
      setMaterialJajeDanga(materialJajeItemSercheValue.r_자재단가)
      setMaterialJajeGubun(materialJajeItemSercheValue.r_자재구분)
    }
  }, [materialJajeItemSercheValue])


  //공장
  let materialGongjangHandle = (e) => {
    e.preventDefault();
    setMaterialGongJang(e.target.value);
  };
  //입고출고구분
  let materialIpchulHandle = (e) => {
    e.preventDefault();
    setMaterialIpchul(e.target.value);
  };
  //자재단위량
  let materialJajeDanwiQuantityHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDanwiQuantity(e.target.value);
  };
  //자재단위
  let materialJajeDanwiHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDanwi(e.target.value);
  };

    //자재지출분류
    let materialJichulBulruHandle = (e) => {
      e.preventDefault();
      setMaterialJichulBulru(e.target.value);
    };

  //자재단가
  let materialJajeDangaHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDanga(e.target.value);
    setMaterialJajeIpgoGumackQuantity(Number(e.target.value) * Number(materialJajeIpgoQuantity))
  };
  //자재입고량 // 공급가액  //세액
  let materialJajeIpgoQuantityHandle = (e) => {
    e.preventDefault();
    setChecked(true)
    setMaterialJajeIpgoQuantity(e.target.value);
    setMaterialJajeIpgoGumackQuantity((Number(materialJajeDanga) * Number(e.target.value)).toFixed(0)) //공급가액
    setMaterialJajeIpgoGumackSeack(Math.floor((Number(materialJajeDanga) * Number(e.target.value)) * 0.1)) //세액
    setMaterialJajeIpgoGumackSegum(((Number(materialJajeDanga) * Number(e.target.value).toFixed(0)) + (Math.floor((Number(materialJajeDanga) * Number(e.target.value)) * 0.1)))) //세금계산서 금액
  };

  const checkdHandle = (event) => {
    event.target.checked ? setChecked(true) : setChecked(false);
    if (checked === false) {
      setMaterialJajeIpgoGumackSeack(Math.floor((Number(materialJajeDanga) * Number(materialJajeIpgoQuantity)) * 0.1)) //세액
      setMaterialJajeIpgoGumackSegum(((Number(materialJajeDanga) * Number(materialJajeIpgoQuantity).toFixed(0)) + (Math.floor((Number(materialJajeDanga) * Number(materialJajeIpgoQuantity)) * 0.1)))) //세금계산서 금액
    }
    else if (checked === true) {
      setMaterialJajeIpgoGumackSeack('0')
      setMaterialJajeIpgoGumackSegum(((Number(materialJajeDanga) * Number(materialJajeIpgoQuantity).toFixed(0)))) //세금계산서 금액
    }
  };

  //자재구분
  let materialJajeGubunHandle = (e) => {
    e.preventDefault();
    setMaterialJajeGubun(e.target.value);
  };

  //자재입출일자
  let materialJajeIpchulDateHandle = (e) => {
    e.preventDefault();
    setMaterialJajeIpChulDate(e.target.value);
  };

  //자재지급월
  let materialJajeDateTimeHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDateTime(e.target.value);
  };
  //결재금액
  let materialJajeIpgoGigubGumackHandle = (e) => {
    e.preventDefault();
    setMaterialJajeIpgoGigubGumack(e.target.value);
  };

  //결재유무
  let materialGeljeHandleHandle = (e) => {
    e.preventDefault();
    setMaterialGelje(e.target.value);
  };

  //결재지급일자
  let materialJajeJigubDateTimeHandle = (e) => {
    e.preventDefault();
    setMaterialJajeJigubDateTime(e.target.value);
  };

  //기타기록사항
  let materialJajeDescriptionHandle = (e) => {
    e.preventDefault();
    setMaterialJajeDescription(e.target.value);
  };

  //개행처리
  const materialJajeDescriptionKeyDownHandle = (e) => {
    if (e.key === 'Enter') {
      setMaterialJajeDescription(e.target.value + "\n");  //개행처리됨.
    }
  };

  //폼전송 엔트키 전송방지
  const checkKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
    }
  };

  //검색
  const handlesetMaterialJajeItemSercheChange = (e) => {
    e.preventDefault();
    setMaterialJajeItemSerche(e.target.value)
  }

  //검색엔트실행
  const handlesetMaterialJajeItemSercheEnter = (e) => {
    e.preventDefault();
    if (e.key === 'Enter') {
      if (materialJajeItemSerche !== '') {
        setMaterialJajeModal(true)
        // console.log('실행')
      }
      else {
        console.log('실행안됨')
      }
    }
  }

  //입고버튼 전송실행
  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData()
    formData.append('Id', materialJajeId)
    formData.append('ms_공장구분', materialGongJang)
    formData.append('ms_입고출고구분', materialIpchul)
    // formData.append('ms_입출일자', moment().format('YYYY-MM-DD HH:mm'))
    formData.append('ms_업체명', materialUpche)
    formData.append('ms_업체코드', materialCodeNo)
    formData.append('ms_자재수불', materialSubul)
    formData.append('ms_계정과목코드', materialGamokCode)
    formData.append('ms_계정과목내용', materialGamok)
    formData.append('ms_자재코드', materialJajeCode)
    formData.append('ms_자재품번', materialJajeItem)
    formData.append('ms_자재규격', materialJajeStandader)
    formData.append('ms_자재지출분류', materialJichulBulru)
    formData.append('ms_단위량', materialJajeDanwiQuantity)
    formData.append('ms_단위', materialJajeDanwi)
    formData.append('ms_자재단가', materialJajeDanga)
    formData.append('ms_수량', materialJajeIpgoQuantity)
    formData.append('ms_세액', materialJajeIpgoGumackSeack)    //세액
    formData.append('ms_금액', materialJajeIpgoGumackQuantity)
    formData.append('ms_자재구분', materialJajeGubun)
    formData.append('ms_입출일자', moment(materialJajeIpChulDate).format('YYYY-MM-DD')) //자재입출일자
    formData.append('ms_결재지급월', moment(materialJajeDateTime).format('YYYYMM'))
    formData.append('ms_결재지급금액', materialJajeIpgoGigubGumack)
    formData.append('ms_결재유무', materialGelje)
    formData.append('ms_결재지급일자', moment(materialJajeJigubDateTime).format('YYYY-MM-DD'))
    formData.append('ms_자재설명', materialJajeDescription)
    formData.append('ms_등록일자', moment(props.materialInputListEditValue.ms_등록일자).format('YYYY-MM-DD HH:mm'))
    formData.append('ms_등록자', props.urlpw)

    addOrEdit(formData)
    props.setMaterialInputListEditModal(false);
  }

  return (
    <div>
      <Modal open={props.materialInputListEditModal}>
        <Box sx={style}>
          <div>
            <Typography
              id="modal-modal-titledlq"
              style={{
                fontFamily: 'D2Coding',
                fontSize: '24px',
                color: 'green',
              }}
            >
              구매자재[입출]수정
            </Typography>
          </div>

          <Form onSubmit={handleSubmit} onKeyDown={checkKeyDown}>
            <div>
              <div>
                <Paper variant="outlined" square style={panelStyle}>
                  <StyledTextField style={{ marginTop: 10 }}
                    //disabled
                    size="small"
                    label="구매자재검색"
                    placeholder="검색[Enter]"
                    name="materialJajeItemSerche"
                    InputProps={{
                      inputProps: { style: { textAlign: "center" } }
                    }}
                    value={materialJajeItemSerche}
                    onChange={handlesetMaterialJajeItemSercheChange}
                    onKeyUp={handlesetMaterialJajeItemSercheEnter}
                    onClick={() => {
                      if (materialJajeItemSerche !== '') {
                        setMaterialJajeItemSerche('');
                      }
                    }}
                  />
                </Paper>
              </div>
              <br></br>
              <hr style={{ margin: 0 }} />
              <div>
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 200, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialUpche === '' ? { shrink: false } : { shrink: true }
                  }
                  label="구매업체상호"
                  name="materialUpche"
                  size="small"
                  value={materialUpche === '' ? '' : materialUpche}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 120, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialCodeNo === '' ? { shrink: false } : { shrink: true }
                  }
                  label="구매업체코드"
                  name="materialCodeNo"
                  size="small"
                  value={materialCodeNo === '' ? '' : materialCodeNo}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialSubul === '' ? { shrink: false } : { shrink: true }
                  }
                  label="자재수불"
                  name="materialSubul"
                  size="small"
                  value={materialSubul === '' ? '' : materialSubul}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 120, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialGamokCode === '' ? { shrink: false } : { shrink: true }
                  }
                  label="계정과목코드"
                  name="materialGamoKCode"
                  size="small"
                  value={materialGamokCode === '' ? '' : materialGamokCode}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialGamok === '' ? { shrink: false } : { shrink: true }
                  }
                  label="과목"
                  name="materialGamok"
                  size="small"
                  value={materialGamok === '' ? '' : materialGamok}
                />
              </div>
              <div>
                <TextField
                  disabled
                  required //필수등록
                  // onChange={materialJajeCodeNoHandle}
                  style={{ width: 100, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeCode === '' ? { shrink: false } : { shrink: true }
                  }
                  id=""
                  label="자재코드"
                  name="materialJajeCodeNo"
                  size="small"
                  value={materialJajeCode ? materialJajeCode : ''}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeItem === '' ? { shrink: false } : { shrink: true }
                  }
                  label="자재품번"
                  name="materialJajeItem"
                  size="small"
                  value={materialJajeItem ? materialJajeItem : ''}
                />
                <TextField
                  disabled
                  required //필수등록
                  style={{ width: 250, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeStandader === '' ? { shrink: false } : { shrink: true }
                  }
                  label="자재규격[품명]"
                  name="materialJajeStandader"
                  size="small"
                  value={materialJajeStandader ? materialJajeStandader : ''}
                />
                <FormControl
                  required //필수등록
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  size="small"
                  >
                  <InputLabel>지출분류</InputLabel>
                  <CssSelect
                    variant="outlined"
                    value={materialJichulBulru ? materialJichulBulru : ''}
                    onChange={materialJichulBulruHandle}
                    label="지출분류"
                  >
                    <MenuItem value=""><div style={{ color: 'red' }}>지정없음</div></MenuItem>
                    <MenuItem value={'고정비용'}>고정비용</MenuItem>
                    <MenuItem value={'변동비용'}>변동비용</MenuItem>
                    <MenuItem value={'일반비용'}>일반비용</MenuItem>
                    <MenuItem value={'카드비용'}>카드비용</MenuItem>
                    <MenuItem value={'세액비용'}>세액비용</MenuItem>
                    <MenuItem value={'자동이체'}>자동이체</MenuItem>
                    <MenuItem value={'개인비용지출'}><div style={{ color: 'darkorange' }}>개인비용지출</div></MenuItem>
                    <MenuItem value={'퇴직통장지출'}><div style={{ color: 'darkorange' }}>퇴직통장지출</div></MenuItem>
                    <MenuItem value={'부가통장지출'}><div style={{ color: 'darkorange' }}>부가통장지출</div></MenuItem>
                    <MenuItem value={'대출통장지출'}><div style={{ color: 'darkorange' }}>대출통장지출</div></MenuItem>
                    {/* <MenuItem value={'기타비용'}><div style={{ color: 'blue' }}>기타비용</div></MenuItem> */}
                  </CssSelect>
                </FormControl>

              </div>
              <hr />
              <div>
                <FormControl
                  required //필수등록
                  variant="outlined"
                  style={{ minWidth: 150, float: 'center', marginTop: '0px', marginBottom: '8px', marginRight: '2px' }}
                  size="small"
                >
                  <InputLabel>우리공장</InputLabel>
                  <CssSelect
                    required //필수등록
                    variant="outlined"
                    value={materialGongJang ? materialGongJang : ''}
                    onChange={materialGongjangHandle}
                    label="우리공장"
                  >
                    <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                    <MenuItem value={'정진P&G'}>정진P&G</MenuItem>
                    <MenuItem value={'(주)제이콥'}>(주)제이콥</MenuItem>
                  </CssSelect>
                </FormControl>
                <FormControl
                  required //필수등록
                  variant="outlined"
                  style={{ minWidth: 100, float: 'center', marginTop: '0px', marginBottom: '8px', marginRight: '2px' }}
                  size="small"
                >
                  <InputLabel>입출</InputLabel>
                  <CssSelect
                    required //필수등록
                    variant="outlined"
                    value={materialIpchul ? materialIpchul : ''}
                    onChange={materialIpchulHandle}
                    label="입출"
                  >
                    <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                    <MenuItem value={'입고'}>입고</MenuItem>
                    <MenuItem value={'출고'}>출고</MenuItem>
                  </CssSelect>
                </FormControl>
              </div>
              <div>
                <CssTextField
                  required //필수등록
                  style={{ width: 150, float: 'center', marginRight: '2px', marginTop: '1px', textAlign: 'right' }}
                  variant="outlined"
                  onChange={materialJajeDanwiQuantityHandle}
                  InputLabelProps={
                    materialJajeDanwiQuantity === '' ? { shrink: false } : { shrink: true }
                  }
                  label="단위량[단위별]"
                  name="materialJajeDanwiQuantity"
                  size="small"
                  value={materialJajeDanwiQuantity ? materialJajeDanwiQuantity : ''}
                />
                <FormControl
                  required
                  variant="outlined"
                  style={{ minWidth: 100, float: 'center', marginTop: '1px', marginRight: '2px', }}
                  size="small"
                >
                  <InputLabel>단위</InputLabel>
                  <CssSelect
                    variant="outlined"
                    value={materialJajeDanwi ? materialJajeDanwi : ''}
                    onChange={materialJajeDanwiHandle}
                    label="단위"
                  >
                    <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                    <MenuItem value={'원'}>원</MenuItem>
                    <MenuItem value={'g'}>g</MenuItem>
                    <MenuItem value={'Kg'}>Kg</MenuItem>
                    <MenuItem value={'Ea'}>Ea[개]</MenuItem>
                    <MenuItem value={'Box'}>Box</MenuItem>
                    <MenuItem value={'Can'}>Can</MenuItem>
                    <MenuItem value={'㎖'}>㎖</MenuItem>
                    <MenuItem value={'ℓ'}>ℓ</MenuItem>
                    <MenuItem value={'갤런(gal)'}>갤런(gal)</MenuItem>
                    <MenuItem value={'말'}>말</MenuItem>
                    <MenuItem value={'포'}>포</MenuItem>
                    <MenuItem value={'드럼'}>드럼</MenuItem>
                    <MenuItem value={'mm'}>mm</MenuItem>
                    <MenuItem value={'Cm'}>Cm</MenuItem>
                    <MenuItem value={'m'}>m</MenuItem>
                    <MenuItem value={'P/L'}>P/L[파렛트]</MenuItem>
                    <MenuItem value={'월'}>월</MenuItem>
                  </CssSelect>
                </FormControl>
                <CssTextField
                  required //필수등록
                  onChange={materialJajeDangaHandle}
                  style={{ width: 100, float: 'center', marginTop: '1px', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeDanga === '' ? { shrink: false } : { shrink: true }
                  }
                  label="단가"
                  name="materialJajeDanga"
                  size="small"
                  value={materialJajeDanga ? materialJajeDanga : ''}
                />
              </div>
              <div>
                <CssTextField
                  required //필수등록
                  onChange={materialJajeIpgoQuantityHandle}
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeIpgoQuantity === '' ? { shrink: false } : { shrink: true }
                  }
                  label="입고량"
                  name="materialJajeDanga"
                  size="small"
                  value={materialJajeIpgoQuantity ? materialJajeIpgoQuantity : ''}
                />
                <CssTextField
                  disabled
                  required //필수등록
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeIpgoGumackQuantity === '' ? { shrink: false } : { shrink: true }
                  }
                  label="공급가액"
                  name="materialJajeIpgoGumackQuantity"
                  size="small"
                  value={materialJajeIpgoGumackQuantity ? materialJajeIpgoGumackQuantity : ''}
                />
                <CssTextField
                  disabled
                  required //필수등록
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeIpgoGumackSeack === '' ? { shrink: false } : { shrink: true }
                  }
                  label="세액"
                  name="materialJajeIpgoGumackSeack"
                  size="small"
                  value={materialJajeIpgoGumackSeack ? materialJajeIpgoGumackSeack : ''}
                />
                <FormControl className={classes01.formControl} size='small'  >
                  <FormControlLabel
                    labelPlacement="end"
                    control={<Checkbox checked={checked} onChange={checkdHandle} />}
                    label="세액"
                  />
                </FormControl>
                <CssTextField
                  disabled
                  required //필수등록
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeIpgoGumackSegum === '' ? { shrink: false } : { shrink: true }
                  }
                  label="계산서금액"
                  name="materialJajeIpgoGumackSegum"
                  size="small"
                  value={materialJajeIpgoGumackSegum ? materialJajeIpgoGumackSegum : ''}
                />
              </div>
              <div>
                <FormControl
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  size="small"
                >
                  <InputLabel>자재구분</InputLabel>
                  <CssSelect
                    variant="outlined"
                    value={materialJajeGubun ? materialJajeGubun : ''}
                    onChange={materialJajeGubunHandle}
                    label="자재구분"
                  >
                    <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem>
                    <MenuItem value={'피착'}>피착</MenuItem>
                    <MenuItem value={'피막'}>피막</MenuItem>
                    <MenuItem value={'착색'}>착색</MenuItem>
                    <MenuItem value={'접착'}>접착</MenuItem>
                    <MenuItem value={'에칭'}>에칭</MenuItem>
                    <MenuItem value={'공통'}>공통</MenuItem>
                    <MenuItem value={'기타'}>기타</MenuItem>
                  </CssSelect>
                </FormControl>
                <CssTextField
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '10px', float: 'center', }}
                  size="small"
                  label="자재입출일자"
                  type="date"
                  //type="datetime-local"
                  format="yyyy-MM-dd"
                  value={moment(materialJajeIpChulDate).format('YYYY-MM-DD')}
                  InputLabelProps={{ shrink: true, }}
                  onChange={materialJajeIpchulDateHandle}
                />
              </div>
              <div>
                <CssTextField
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '10px', float: 'center', }}
                  size="small"
                  label="지불월"
                  // type="month"
                  type="month"
                  format="yyyy-MM"
                  // value={moment().format('yyyy-MM')}
                  value={moment(materialJajeDateTime).format('YYYY-MM')}
                  InputLabelProps={{ shrink: true, }}
                  onChange={materialJajeDateTimeHandle}
                />
                <IconButton
                  onClick={() => { setMaterialJajeDateTime(moment().format('yyyy-MM')) }}
                  style={{ padding: '8px 0px 0px 0px' }} >
                  <AddBoxIcon style={{ fontSize: 40, margin: 0, color: 'green' }} />
                </IconButton>
                <CssTextField
                  // required //필수등록
                  style={{ width: 150, marginTop: '10px', float: 'center', marginRight: '2px', }}
                  variant="outlined"
                  InputLabelProps={
                    materialJajeIpgoGumackQuantity === '' ? { shrink: false } : { shrink: true }
                  }
                  label="결재금액"
                  name="materialJajeIpgoGigubGumack"
                  size="small"
                  value={materialJajeIpgoGigubGumack ? materialJajeIpgoGigubGumack : ''}
                  onChange={materialJajeIpgoGigubGumackHandle}
                />
                <FormControl
                  required //필수등록
                  variant="outlined"
                  style={{ minWidth: 100, float: 'center', marginTop: '10px', marginBottom: '8px', marginRight: '2px' }}
                  size="small"
                >
                  <InputLabel>결재</InputLabel>
                  <CssSelect
                    required //필수등록
                    variant="outlined"
                    value={materialGelje ? materialGelje : ''}
                    onChange={materialGeljeHandleHandle}
                    label="결재"
                  >
                    {/* <MenuItem value=""><div style={{ color: 'red' }}>없음</div></MenuItem> */}
                    <MenuItem value={'미결'}>미결</MenuItem>
                    <MenuItem value={'즉시'}>즉시</MenuItem>
                    <MenuItem value={'결재'}>결재</MenuItem>
                    <MenuItem value={'보류'}>보류</MenuItem>
                  </CssSelect>
                </FormControl>
                <CssTextField
                  required
                  variant="outlined"
                  style={{ minWidth: 150, marginTop: '10px', float: 'center', }}
                  size="small"
                  label="결재지급일자"
                  type="date"
                  format="yyyy-MM-dd"
                  // value={moment().format('yyyy-MM')}
                  value={moment(materialJajeJigubDateTime).format('YYYY-MM-DD')}
                  InputLabelProps={{ shrink: true, }}
                  onChange={materialJajeJigubDateTimeHandle}
                />
              </div>
              <div>
                <CssTextField
                  style={{ width: 300, marginTop: '10px' }}
                  label="Discription[기타기록]"
                  placeholder="기타 기록하기"
                  multiline
                  variant="outlined"
                  value={materialJajeDescription}
                  inputProps={{ className: classes.textarea }}
                  onChange={materialJajeDescriptionHandle}
                  onKeyDown={materialJajeDescriptionKeyDownHandle}
                />
              </div>
            </div>
            <div style={{ marginTop: '10px' }}>
              <Button
                type="submit"
                startIcon={<SaveIcon />}
                variant="contained"
                style={{
                  height: '37px',
                  background: '#388e3c',
                  color: 'white',
                  width: 100,
                  marginRight: '2px',
                  float: 'center',
                }}
              >
                수정
              </Button>
              <Button
                onClick={() => {
                  props.setMaterialInputListEditModal(false);
                }}
                variant="contained"
                startIcon={<CloseIcon />}
                style={{
                  height: '37px',
                  width: 100,
                  background: '#689f38',
                  color: 'white',
                  marginTop: '2px',
                  float: 'center',
                }}
              >
                나가기
              </Button>
            </div>
          </Form>
        </Box>
      </Modal>
      {materialJajeModal === true ? <MaterialJajeSerche
        materialJajeModal={materialJajeModal} setMaterialJajeModal={setMaterialJajeModal}
        materialJajeItemSerche={materialJajeItemSerche} setMaterialJajeItemSercheValue={setMaterialJajeItemSercheValue}
      /> : null}
    </div>
  );
}

export default MaterialInputListEdit;
